import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, TextField, Typography } from "@mui/material";

import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { canUpdateTemplate, canUpdateTemplateFooter, getTextCharacterLimit, isTemplateCategoryAuthentication, maxFooterChars } from "../../../channels/global/whatsapp/templates/utils";
import { useSearchParams } from "react-router-dom";
import { shouldShowFooterTextField } from "../../constant";

const WhatsAppTemplateFormFooter = (props: any) => {
    
    const { handleChangeText, handleExpirationChange, handleAddExpiryTimeChange } = props;

    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    const existingTemplateData = useTemplateLibraryStore((state) => state.existingTemplateData);
    const templateStatusDetails = useTemplateLibraryStore((state) => state.templateStatusDetails);
    const setCreateTemplatePayload = useTemplateLibraryStore((state) => state.setCreateTemplatePayload);
    const interactiveTypeList = useTemplateLibraryStore((state) => state.interactiveTypeList);
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);
    const whatsappTemplateTypes = useTemplateLibraryStore((state) => state.whatsappTemplateTypes);
    const addExpiryTimeForCode = useTemplateLibraryStore((state) => state.addExpiryTimeForCode);
    const setAddExpiryTimeForCode = useTemplateLibraryStore((state) => state.setAddExpiryTimeForCode);

    const [searchParams] = useSearchParams();
    let draftId = searchParams.get('draft_id');

    const isAuthenticationTemplate = isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id);

    const handleFooterTextDisabled = () => {
        return (
            (!canUpdateTemplateFooter(templateStatusDetails?.whatsapp_template_metadata?.meta_whatsapp_template_status_name, createTemplatePayload, whatsappTemplateTypes, draftId, existingTemplateData, createTemplatePayload?.whatsapp_template_id))
            || isAuthenticationTemplate
        )
    }

    return (
        <Accordion defaultExpanded={true} className={`${styles.accordion}`}>
            
            <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className={styles.accordion__summary}>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                    <span className={styles.accordion__summary__text}>
                        Footer
                    </span>
                    <span className={styles.accordion__summary__value}>
                        {`${createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value?.length ?? 0}/${getTextCharacterLimit(createTemplatePayload, interactiveTypeList, "footer text limit")}`}
                    </span>
                </Grid>
            </AccordionSummary>

            <Divider sx={{ width: "100%", opacity: "1" }} />


            <AccordionDetails className={styles.accordion__details}>

                {isAuthenticationTemplate && (
                    <div className={styles.whatsappTemplateFormFooter__expirationTimeContainer}>
                        <div className={styles.whatsappTemplateFormFooter__expirationTimeRow}>
                            Add expiry time for the code
                            <input
                                type="checkbox"
                                className={styles.whatsappTemplateFormBody__securityRecommendationCheckbox}
                                checked={addExpiryTimeForCode}
                                onChange={(e) => handleAddExpiryTimeChange(e.target.checked)}
                                disabled={!!createTemplatePayload?.whatsapp_template_id}
                            />
                        </div>
                        
                        {addExpiryTimeForCode && (
                            <div className={styles.whatsappTemplateFormFooter__expirationTimeRow}>
                                Expiration Time
                                <input
                                    type="number"
                                    min={1}
                                    max={90}
                                    className={styles.whatsappTemplateFormFooter__expirationTimeInput}
                                    value={createTemplatePayload?.whatsapp_template_data?.whatsapp_template_code_expiration_minutes || ""}
                                    onChange={(e) => handleExpirationChange(e.target.value)}
                                    disabled={!!createTemplatePayload?.whatsapp_template_id}
                                />
                            </div>
                        )}
                    </div>
                )}
                
                {shouldShowFooterTextField(isAuthenticationTemplate, addExpiryTimeForCode) &&
                    <TextField
                        // disabled={createTemplatePayload?.whatsapp_template_id ? true : false}
                        // disabled={!canUpdateTemplate(templateStatusDetails?.whatsapp_template_metadata?.meta_whatsapp_template_status_name, createTemplatePayload?.whatsapp_template_flag_interactive_message, draftId) || !(existingTemplateData && existingTemplateData?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0)}
                        disabled={handleFooterTextDisabled()}
                        variant="outlined"
                        // value={footerText} 
                        value={createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value ?? ""}
                        size='small'
                        className={styles.templateGlobalTextfield}
                        onChange={(event: any) => {
                            handleChangeText(event, 'footer');

                            let maximumFooterCharacterLimit = getTextCharacterLimit(createTemplatePayload, interactiveTypeList, "footer text limit") ?? maxFooterChars;
                            if(event.target.value.length <= maximumFooterCharacterLimit){
                                setCreateTemplatePayload({
                                    ...createTemplatePayload,
                                    whatsapp_template_data: {
                                        ...createTemplatePayload?.whatsapp_template_data,
                                        whatsapp_template_footer: {
                                            ...createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer,
                                            whatsapp_template_footer_id: createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_id ? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_id : 0,
                                            // whatsapp_template_footer_data: [{ whatsapp_template_footer_data_value: event.target.value }]
                                            whatsapp_template_footer_value: event.target.value,
                                        }
                                    }
                                })
                            }
                        }}
                        // helperText={`${createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value?.length ?? 0}/${getTextCharacterLimit(createTemplatePayload, interactiveTypeList, "footer text limit")}`}
                        fullWidth
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                            },
                        }}
                        inputProps={{ dir: 'auto' }}
                        autoComplete='off'
                        placeholder='Enter footer text here'
                        FormHelperTextProps={{
                            style: {
                                textAlign: 'right',
                                fontSize: '14px',
                                fontWeight: '600'
                            }
                        }}
                    />
                }

            </AccordionDetails>

        </Accordion>
    )

}

export default WhatsAppTemplateFormFooter;
